import React, { useState } from "react";
import "./commonPopup.scss";
import { ClickAwayListener, Dialog } from "@material-ui/core";
import close_icon from "../../../assets/crossIcon.svg";
import { withStyles } from "@material-ui/styles";
import dropdown_blue from "../../../assets/dropdown_blue.svg";

const styles = {
  dialogPaper: {
    maxWidth: "660px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    margin: window.innerWidth > 768 ? "" : "19px",
  },
};

const CommonPopup = (props) => {
  const {
    classes,
    componentSpecificPopup,
    hideCloseText,
    hideCloseIcon,
    openPopup,
    heading,
    titleImg,
    title,
    subtitle,
    dropdown,
    options,
    selectedValue,
    showTextArea,
    inputPlaceholder,
    inputValue,
    errorMsg,
    leftBtn,
    rightBtn,
    containerStyle,
    handleClosePopup,
    handleOnChangeInput,
    handleDropdownSelection,
    handleLeftBtnClick,
    handleRightBtnClick,
    hideFooter,
    disableLeft,
  } = props;

  const [showOptions, setShowOptions] = useState(false);

  // Actions ===>

  const toggleDropdown = () => {
    setShowOptions(!showOptions);
  };

  // <===

  // Display UI

  const displayCommonPopup = () => {
    return (
      <>
        {componentSpecificPopup ? (
          displayComponentSpecificPopup()
        ) : (
          <Dialog
            open={openPopup}
            classes={{
              paper: classes.dialogPaper,
            }}
          >
            {displayPopupContent()}
          </Dialog>
        )}
      </>
    );
  };

  const displayComponentSpecificPopup = () => {
    return (
      <div className="component-specific-popup-cont">
        <div className="background-drop">{displayPopupContent()}</div>
      </div>
    );
  };

  const displayPopupContent = () => {
    return (
      <div className="common-popup-container">
        <div className="common-popup-header-close-cont">
          {heading && (
            <div className="common-popup-header-main-heading">{heading}</div>
          )}
          <div className="common-popup-header-close" onClick={handleClosePopup}>
            {!hideCloseText && "Close"}
            {!hideCloseIcon && <img src={close_icon} alt="" />}
          </div>
        </div>
        {titleImg && (
          <div className="common-popup-titleImg">
            <img src={titleImg} alt="" />
          </div>
        )}
        <div className="common-popup-cont" style={containerStyle}>
          {title && <div className="common-popup-title">{title}</div>}
          {subtitle && <div className="common-popup-subtitle">{subtitle}</div>}
          {dropdown && displayDropdown()}
          {showTextArea && displayTextArea()}
        </div>
        {!hideFooter && displayPopupFooter()}
      </div>
    );
  };

  const displayDropdown = () => {
    return (
      <div className="common-popup-dropdown-container">
        <div onClick={toggleDropdown} className="common-popup-dropdown-cont">
          <div className="common-popup-selected-value">{selectedValue}</div>
          <img
            src={dropdown_blue}
            alt=""
            className={
              "common-popup-dropdown-icon " +
              (showOptions ? "common-popup-dropdown-icon-selected" : "")
            }
          />
        </div>
        {showOptions && (
          <ClickAwayListener onClickAway={toggleDropdown}>
            <div className="common-popup-dropdown">
              {options.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    handleDropdownSelection(item);
                    toggleDropdown();
                  }}
                  className={
                    "common-popup-dropdown-values " +
                    (item.selected
                      ? "common-popup-dropdown-value-selected"
                      : "")
                  }
                >
                  {item.label}
                </div>
              ))}
            </div>
          </ClickAwayListener>
        )}
      </div>
    );
  };

  const displayTextArea = () => {
    return (
      <>
        <div className="common-popup-textarea-cont">
          <textarea
            placeholder={inputPlaceholder}
            value={inputValue}
            onChange={handleOnChangeInput}
            className="common-popup-textarea"
          />
        </div>
        {errorMsg && (
          <div className="common-popup-textarea-error-msg-cont">
            <div className="common-popup-textarea-error-msg">{errorMsg}</div>
          </div>
        )}
      </>
    );
  };

  const displayPopupFooter = () => {
    return (
      <div className="common-popup-footer">
        <div
          className={
            disableLeft
              ? "common-popup-footer-left-btn disabled-left-btn"
              : "common-popup-footer-left-btn"
          }
          onClick={handleLeftBtnClick}
          disabled={disableLeft}
        >
          {leftBtn ?? "Yes"}
        </div>
        <div
          className="common-popup-footer-right-btn"
          onClick={handleRightBtnClick}
        >
          {rightBtn ?? "No"}
        </div>
      </div>
    );
  };

  // <===

  return <>{displayCommonPopup()}</>;
};

export default withStyles(styles)(CommonPopup);
